// src/com/bbs_pkg/user_bbs/UserBbsInfo.js
import React, {useEffect, useState, useRef} from 'react';
//import { styled  } from '@mui/material/styles';
import CachedIcon from '@mui/icons-material/Cached'; // refresh
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PageviewIcon from '@mui/icons-material/Pageview';
import {ContentConainer, ContentHeader, ControlBox, ToolBox} from '../../../common/TopViewControl';
import { useConfirmDialog } from '../../../common/AppConfirmDialog';
import FlexyTable from '../../../common/flexytable/FlexyTable';
import DateRangePicker from '../../../common/DateRangePicker';
//import { BbsInfoDict } from '../BbsInfoDict';
import ValueMisc from '../../../value/ValueMisc';
//import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { AppObject, AppStyle } from '../../../value/AppConst';
import { userBbsInfoListRepo, userBbsCommentListRepo, userInfoRepo } from '../../../value/AppModel';
import {
    LIST_USER_BBS_INFO, GET_USER_BBS_INFO, ADD_USER_BBS_INFO, EDIT_USER_BBS_INFO,
    REMOVE_USER_BBS_INFO, SET_USER_BBS_INFO_STATUS
} from './UserBbsInfoGql';
// import { LIST_BBS_INFO, GET_BBS_INFO, ADD_BBS_INFO, EDIT_BBS_INFO, REMOVE_BBS_INFO } from '../BbsInfoGql';
import { useLazyQuery, useMutation, useReactiveVar } from '@apollo/client';
import { useAlertSetter } from '../../../api/app-hook';
import UserBbsInfoView from './UserBbsInfoView';
import UserBbsInfoInput from './UserBbsInfoInput';
import { Button, IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';
import { UserBbsInfoDict } from './UserBbsInfoDict';

/**
 * 사용자 게시판 View-Controller
 * @param {*} param0 
 * @returns 
 */
export default function UserBbsInfo({
    viewServiceTags,
}) {
    const sessionInfo = useReactiveVar(userInfoRepo);
    // const [dateFrom, setDateFrom] = useState(dayjs(ValueMisc.getDateAgo(5)));
    const [dateFrom, setDateFrom] = useState(ValueMisc.getYMD(ValueMisc.getDateAgo(5)));
    // const [dateTo, setDateTo] = useState(dayjs(new Date()));
    const [dateTo, setDateTo] = useState(ValueMisc.getYMD());
    const [viewerState, setViewerState] = useState(AppObject.EmptyViewerState);
    const [editorState, setEditorState] = useState(AppObject.EmptyViewerState);
    const userBbsInfoListData = useReactiveVar(userBbsInfoListRepo); // {when:0, records:[]}
    const openConfirmDialog = useConfirmDialog();
    const addAlert = useAlertSetter();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const lastReloadRef = useRef(0);
    const isEditingRef = useRef(false); // 플래그: 편집모드인지 보기모드인지 구분

    const [getUserBbsInfoList, responseList] = useLazyQuery(LIST_USER_BBS_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data) => onCompleteList(data),
        onError: (error) => addAlert({title: UserBbsInfoDict.errorTitle.Get, message: [error.message]})
    });

    const [getUserBbsInfoItem, responseItem] = useLazyQuery(GET_USER_BBS_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data) => onCompleteGetItem(data),
        onError: (error) => addAlert({title: UserBbsInfoDict.errorTitle.Get, message: [error.message]})
    });

    const [addUserBbsInfo, responseAdd] = useMutation(ADD_USER_BBS_INFO, {
        onCompleted: (data) => onCompleteAdd(data),
        onError: (error) => addAlert({title: UserBbsInfoDict.errorTitle.Add, message: [error.message]})
    });

    const [editUserBbsInfo, responseEdit] = useMutation(EDIT_USER_BBS_INFO, {
        onCompleted: (data) => onCompleteEdit(data),
        onError: (error) => addAlert({title: UserBbsInfoDict.errorTitle.Edit, message: [error.message]})
    });

    const [removeUserBbsInfo, responseRemove] = useMutation(REMOVE_USER_BBS_INFO, {
        onCompleted: (data) => onCompleteRemove(data),
        onError: (error) => addAlert({title: UserBbsInfoDict.errorTitle.Remove, message: [error.message]})
    });

    const [setUserBbsInfoStatus, responseSetStatus] = useMutation(SET_USER_BBS_INFO_STATUS, {
        onCompleted: (data) => onCompleteSetStatus(data),
        onError: (error) => addAlert({title: '상태설정', message: [error.message]})
    });

    const getWholeUserBbsInfoList = () => {
        const from = dateFrom || ValueMisc.getYMD(ValueMisc.getDateAgo(5));
        const till = dateTo || ValueMisc.getYMD();
        getUserBbsInfoList({variables:{dateFrom: from, dateTill: till }});
        lastReloadRef.current = new Date().getTime()/1000;
    };

    useEffect(()=>{
        const diff = new Date().getTime()/1000 - userBbsInfoListData.when;
        if(diff > 300) {
            getWholeUserBbsInfoList();
        }
    }, []);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteList = (data) => {
        if(data.userBbsInfoList) {
            userBbsInfoListRepo({when:new Date().getTime()/1000, records:data.userBbsInfoList});
        }
    };

    const onCompleteGetItem = (data) => {
        if(data.userBbsInfoItem) {
            if(isEditingRef.current) setEditorState({open:true, item:data.userBbsInfoItem.userBbsInfo});
            else {
                setViewerState({
                    open:true,
                    item:data.userBbsInfoItem.userBbsInfo,
                });
            }
            userBbsCommentListRepo({when:new Date().getTime()/1000, records:data.userBbsInfoItem.comments});
        }
        else {
            addAlert({title: UserBbsInfoDict.errorTitle.Get, message: ['게시물을 찾을 수 없습니다.']});
        }
    };

    const onCompleteAdd = (data) => {
        if(data.userBbsInfoAdd.ok) {
            setEditorState(AppObject.EmptyViewerState);
            getWholeUserBbsInfoList();
            const bbsInfoSeq = data.userBbsInfoAdd.item.bbsInfoSeq;
            // 파일 업로드를 할 수 있도록 viewer 열기
            isEditingRef.current = false; // viewer 모드로 열기
            getUserBbsInfoItem({variables:{bbsInfoSeq: bbsInfoSeq}});
        }
        else //setResponseAlert({open:true, resultData: data.bbsInfoAdd, title: ErrorTitle.Add});
            addAlert({title: UserBbsInfoDict.errorTitle.Add, message: [data.userBbsInfoAdd.message]});
    };

    const onCompleteEdit = (data) => {
        isEditingRef.current = false;
        if(data.userBbsInfoEdit.ok) {
            setEditorState(AppObject.EmptyViewerState);
            getWholeUserBbsInfoList();
            // 편집할 때는 파일을 직접 편집화면에서 추가/삭제 할 수 있어.
        }
        else addAlert({title: UserBbsInfoDict.errorTitle.Edit, message: [data.userBbsInfoEdit.message]});
    };

    const onCompleteRemove = (data) => {
        if(data.userBbsInfoRemove.ok)
            getWholeUserBbsInfoList();
        else addAlert({title: UserBbsInfoDict.errorTitle.Remove, message: [data.userBbsInfoRemove.message]});
    };

    const onCompleteSetStatus = (data) => {
        if(data.userBbsInfoSetStatus.ok) {
            getWholeUserBbsInfoList();
            setViewerState(AppObject.EmptyViewerState);
        }
        else addAlert({title: '상태설정', message: [data.userBbsInfoSetStatus.message]});
    };

    // ************** Event Handlers **************

    const onClickReload = () => {
        const diff = new Date().getTime()/1000 - lastReloadRef.current;
        if(diff < 60) {
            enqueueSnackbar('1분 이내에는 재조회 할 수 없습니다.', {variant:'info', autoHideDuration:2000});
        }
        else getWholeUserBbsInfoList();
    };

    const onClickAdd = () => {
        setEditorState({open: true, item: null});
    };

    const onDoubleClickRow = (record) => {
        isEditingRef.current = false;
        getUserBbsInfoItem({variables:{bbsInfoSeq:record.bbsInfoSeq}});
    };

    const onRequestReloadItem = (bbsInfoSeq) => {
        // viewer 또는 editor에서 요청. 따라서 isEditingRef 설정 하면 안됨.
        getUserBbsInfoItem({variables:{bbsInfoSeq: bbsInfoSeq}});
        // List too
        getWholeUserBbsInfoList();
    }

    const onCloseView = () => {
        setViewerState(AppObject.EmptyViewerState);
    };

    const onRequestEditFromViewer = (item) => {
        setViewerState(AppObject.EmptyViewerState);
        isEditingRef.current = true;
        setEditorState({open: true, item: item});
    };

    const onRequestEdit = (item) => {
        isEditingRef.current = true;
        getUserBbsInfoItem({variables:{bbsInfoSeq:item.bbsInfoSeq}});
    };

    const onClickGetList = () => {
        const from = dateFrom; //.format(AppWord.YMD_FOR_INPUT);
        const to = dateTo; //.format(AppWord.YMD_FOR_INPUT);
        const param = {variables:{dateFrom:from, dateTill:to}};
        getUserBbsInfoList(param);
    };

    const onRequestSave = (param, isEdit) => {
        const mutParam = {variables:{userBbsInfo:param}};
        if(isEdit) editUserBbsInfo(mutParam);
        else addUserBbsInfo(mutParam);
    };

    const onRequestSetStatus = (bbsInfoSeq, userBbsStatusCd) => {
        // SET_USER_BBS_INFO_STATUS
        setUserBbsInfoStatus({variables: {bbsInfoSeq, userBbsStatusCd}});
    };

    const confirmRemoveBbsInfo = async (item) => {
        const confirm = await openConfirmDialog({
            title: '게시물 삭제',
            content:['지정한 게시물과 댓글들을 모두 삭제합니다.', '삭제한 게시물은 복구할 수 없습니다. 계속하시겠습니까?'],
        });

        if(confirm) removeUserBbsInfo({variables:{userBbsInfo:{bbsInfoSeq:item.bbsInfoSeq}}});
    };

    const onClickToolOnRow = (toolId, row) => {
        switch(toolId) {
            case AppObject.command.DELETE: confirmRemoveBbsInfo(row); break;
            case AppObject.command.EDIT: onRequestEdit(row); break;
            case AppObject.command.VIEW: onDoubleClickRow(row); break;
            default: return;
        }
    };

    const tools = [
        {id:AppObject.command.VIEW, icon:<PageviewIcon/>, },
        {id:AppObject.command.EDIT, icon:<EditIcon/>, where: (row) => row.regUserId === sessionInfo.user.userId},
        {id:AppObject.command.DELETE, icon:<DeleteForeverIcon/>, color: AppStyle.mui.warning, where: (row) => row.regUserId === sessionInfo.user.userId},
    ];

    const loadingAny
    = responseList.loading || responseItem.loading || responseAdd.loading
    || responseEdit.loading || responseRemove.loading || responseSetStatus.loading;

    return(
        <ContentConainer>
            {viewServiceTags}
            <ContentHeader>
                <ControlBox>
                    <DateRangePicker
                        dateFrom={dateFrom}
                        dateTo={dateTo}
                        onChangeFrom={setDateFrom}
                        onChangeTo={setDateTo}
                    />
                    <Button
                        variant={AppStyle.mui.contained}
                        style={{marginLeft:10}}
                        onClick={onClickGetList}
                        disabled={loadingAny}
                    >
                        조회
                    </Button>
                </ControlBox>
                <ToolBox>
                    <IconButton
                        color={AppStyle.mui.inherit}
                        style={{marginRight:10}}
                        onClick={onClickReload}
                        disabled={loadingAny}
                    >
                        <CachedIcon />
                    </IconButton>
                    <IconButton
                        color={AppStyle.mui.primary}
                        onClick={onClickAdd}
                        disabled={loadingAny}
                    >
                        <NoteAddIcon />
                    </IconButton>
                </ToolBox>
            </ContentHeader>
            <FlexyTable
                name={UserBbsInfoDict.tableProps.tableId}
                tableProps={UserBbsInfoDict.tableProps}
                records={userBbsInfoListData.records}
                onRowDoubleClicked={onDoubleClickRow}
                tools={tools}
                onClickTool={onClickToolOnRow}
            />
            <UserBbsInfoView
                open={viewerState.open}
                item={viewerState.item}
                comments={viewerState.comments}
                onClose={onCloseView}
                onRequestEdit={onRequestEditFromViewer}
                onRequestReload={onRequestReloadItem}
                onRequestSetStatus={onRequestSetStatus}
            />
            <UserBbsInfoInput
                open={editorState.open}
                item={editorState.item}
                onClose={()=>setEditorState(AppObject.EmptyViewerState)}
                responseSaving={editorState.item ? responseEdit : responseAdd}
                onRequestSave={onRequestSave}
                onRequestReload={onRequestReloadItem}
            />
        </ContentConainer>
    );
}
